import { Badge } from '@/components/ui';
import { getCargoSegmentInfo } from '@/utils/cargoListUtils';

interface CargoSegmentBadgeProps {
  /** Raw `segment` value off the wire: 'VL' (VLCC) or 'SM' (Suezmax). */
  segment: string | null | undefined;
}

/**
 * Small VLCC / Suezmax badge derived from a cargo's `segment`. Renders nothing
 * for a missing or unrecognised value - an API predating the view's `Segment`
 * column omits the field entirely, and a raw code is no use to the reader.
 */
export function CargoSegmentBadge({ segment }: CargoSegmentBadgeProps) {
  const info = getCargoSegmentInfo(segment);
  if (!info) return null;
  return (
    <Badge size="sm" variant={info.variant}>
      {info.label}
    </Badge>
  );
}
